module.exports = __webpack_public_path__ + "img/back.12b9a715.svg";